import { createReducer } from '@reduxjs/toolkit';

import { storeSavedQuote } from '../actions';

export default createReducer(
  null,
  /* eslint-disable no-param-reassign */
  {
    [storeSavedQuote]: (state, { payload: { savedQuote } }) => savedQuote,
  },
  /* eslint-enable no-param-reassign */
);
